import * as React from 'react';
import { useStrings } from 'src/providers';
import { StyledFooter, LearnMoreButton } from './StyledFooter';
import { ClydeLogoLink, LogoLinkOptions } from 'src/components/Shared/ClydeLogoLink';
import { ContractDetailsRequestedPromptOptions } from 'src/types/IModal';

interface IFootertProps {
  contractDetailsRequested: (prompt: ContractDetailsRequestedPromptOptions) => void;
  showLearnMore?: boolean;
}

export function Footer({contractDetailsRequested, showLearnMore = true}: IFootertProps) {
  const { learnMoreLink } = useStrings();
  return (
    <StyledFooter>
      {showLearnMore && (
        <LearnMoreButton
          data-test="whats-covered"
          className="learn-more-btn"
          onClick={() => contractDetailsRequested(ContractDetailsRequestedPromptOptions.SELECT)}
          type="button"
        >
          {learnMoreLink}
        </LearnMoreButton>
      )}
      <ClydeLogoLink
        data-test="clyde-logo-select"
        logoType={LogoLinkOptions.PLAIN}
      />
    </StyledFooter>
  );
}
